export default "__VITE_ASSET__dp_qOcHM__"